const LEGACY_KEY = "soapbox:onboarding";
const ONBOARDING_KEY = "truth:onboarding";

function useOnboarding() {
  const checkOnboardingStatus = () => {
    const needsOnboardingLegacy = localStorage.getItem(LEGACY_KEY) === "1";
    const needsOnboarding = localStorage.getItem(ONBOARDING_KEY) === "1";

    if (needsOnboardingLegacy && !needsOnboarding) {
      localStorage.setItem(ONBOARDING_KEY, "1");
      localStorage.removeItem(LEGACY_KEY);
    } else if (needsOnboardingLegacy && needsOnboarding) {
      localStorage.removeItem(LEGACY_KEY);
    }

    return needsOnboardingLegacy || needsOnboarding;
  };

  const startOnboarding = () => {
    localStorage.setItem(ONBOARDING_KEY, "1");
  };

  const endOnboarding = () => {
    localStorage.removeItem(ONBOARDING_KEY);
  };

  return {
    checkOnboardingStatus,
    startOnboarding,
    endOnboarding,
  };
}

export { useOnboarding };
